import { axiosSwagger } from "@/axios";

export const state = {
    // move pin folder
    movePinFolder: {
        loading: false,
        data: [],
    }
}


export const getters = {
}


export const mutations = {
    // MOVE FOLDER
    movePinFolderLoading: (state, loading) => {
        state.movePinFolder.loading = loading;
    },
    setMovePinFolderData: (state, data) => {
        state.movePinFolder.data = data;
    },
}


export const actions = {
    // READ MOVE PIN FOLDER
    async readMovePinFolder({ commit }) {
        commit("movePinFolderLoading", true);

        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;
    
        return await axiosSwagger
          .get(`/api/FileFolder/Pinned/${userData?.deliveryUnit?.id}`)
          .then((response) => {
            commit("setMovePinFolderData", response.data);
            commit("movePinFolderLoading", false);
    
            return response;
          })
          .catch(() => {
            commit("movePinFolderLoading", false);
          });
      }
}
